import navigator from './navigator'
import toolbar from './toolbar'
import stepText from './stepText'
import screenfull from 'screenfull'
import stepList from './stepList'
import { AssetsService } from '@coosmo/shared-utils'

function setupIcons(storyboard, tenant) {
  storyboard.DOM.storyIcon = document.getElementById('toggleChaptersList')
  storyboard.DOM.storyIcon.src = AssetsService.getSvgIcon('story.svg')
  storyboard.DOM.prevStepIcon = document.getElementById('prevStep')
  storyboard.DOM.prevStepIcon.src = AssetsService.getSvgIcon('prevStep.svg')
  storyboard.DOM.nextStepIcon = document.getElementById('nextStep')
  storyboard.DOM.nextStepIcon.src = AssetsService.getSvgIcon('nextStep.svg')
  storyboard.DOM.zoomInIcon = document.querySelector('#zoom-in>img')
  storyboard.DOM.zoomInIcon.src = AssetsService.getSvgIcon('zoom-in-grey.svg')
  storyboard.DOM.zoomOutIcon = document.querySelector('#zoom-out>img')
  storyboard.DOM.zoomOutIcon.src = AssetsService.getSvgIcon('zoom-out-grey.svg')
  storyboard.DOM.toggleStepIcon = document.getElementById(
    'toggleStepContentButton',
  )
  storyboard.DOM.toggleStepIcon.src = AssetsService.getSvgIcon('next-grey.svg')
  storyboard.DOM.creditsImage = document.querySelector('#credits>a>img')
  storyboard.DOM.creditsImage.src = AssetsService.getCreditsImage(tenant)
  storyboard.DOM.logoMobileImage = document.querySelector(
    '#credits-mobile>a>img',
  )
  storyboard.DOM.logoMobileImage.src = AssetsService.getLogoMobile(tenant)
  storyboard.DOM.goHomeButtonOnPremises = document.querySelector('#homePage')
  storyboard.DOM.goHomeButtonOnPremises.src = AssetsService.getSvgIcon(
    'on-premises-home.svg',
  )
}

export default {
  init: function (storyboard, onPremises, tenant) {
    setupIcons(storyboard, tenant)
    storyboard.DOM.spinnerContainer =
      document.getElementById('spinnerContainer')

    storyboard.DOM.viewerContainer = document.getElementById('viewer')

    storyboard.DOM.toggleChaptersList =
      document.getElementById('toggleChaptersList')
    storyboard.DOM.toggleChaptersList.addEventListener('click', function () {
      storyboard.DOM.stepListContainer.classList.remove('hidden')
      storyboard.DOM.stepListContainer.style.opacity = '1'

      const urlParams = new URLSearchParams(window.location.search)
      const myParam = urlParams.get('lang')
      if (myParam === 'en') {
        document.getElementById('closeStepList').innerHTML = 'Go Back'
      } else {
        document.getElementById('closeStepList').innerHTML = 'Torna Indietro'
      }
      navigator.hide(storyboard)
      toolbar.hideButtons(storyboard)
      storyboard.DOM.navigatorAutoHideEnabled = false
    })

    storyboard.DOM.totalStepsContainer = document.getElementById('totalSteps')

    storyboard.DOM.prevStep = document.getElementById('prevStep')
    storyboard.DOM.prevStep.addEventListener('click', function () {
      storyboard.prevStep()
    })

    storyboard.DOM.nextStep = document.getElementById('nextStep')
    storyboard.DOM.nextStep.addEventListener('click', function () {
      storyboard.nextStep()
    })

    storyboard.DOM.navigatorSwitchCheckbox = document.getElementById(
      'inspectorSwitchCheckbox',
    )

    storyboard.DOM.stepContentWidget =
      document.getElementById('stepContentWidget')

    storyboard.DOM.stepTextWrapper = document.getElementById('stepTextWrapper')
    storyboard.DOM.imageTitle = document.getElementById('imageTitle')
    storyboard.DOM.imageAuthor = document.getElementById('imageAuthor')
    storyboard.DOM.stepTitle = document.getElementById('stepTitle')
    storyboard.DOM.stepCaption = document.getElementById('stepCaption')
    storyboard.DOM.stepText = document.getElementById('stepText')

    storyboard.DOM.toggleStepContentButton = document.getElementById(
      'toggleStepContentButton',
    )
    storyboard.DOM.stepContentToggle =
      document.getElementById('stepContentToggle')
    storyboard.DOM.stepContentToggle.addEventListener('click', function (e) {
      if (storyboard.DOM.stepContentWidget.classList.contains('away')) {
        stepText.showStepContent(storyboard)
      } else {
        stepText.hideStepContent(storyboard)
      }
    })

    storyboard.DOM.stepListContainer =
      document.getElementById('stepListContainer')
    storyboard.DOM.storyTitle = document.getElementById('storyTitle')
    storyboard.DOM.stepList = document.getElementById('stepList')

    storyboard.DOM.closeStepList = document.getElementById('closeStepList')
    storyboard.DOM.closeStepList.addEventListener('click', function (e) {
      e.preventDefault()

      if (storyboard.stepper.userStartedLoop) {
        storyboard.activateLoop()
      }

      stepList.close(storyboard)
    })

    storyboard.DOM.changeStory = document.getElementById('changeStory')
    storyboard.DOM.changeStory.addEventListener('click', function (e) {
      storyboard.firstLaunch = true
      storyboard.DOM.stepListContainer.classList.add('hidden')
      storyboard.collectionDOM.collectionListContainer.classList.remove(
        'hidden',
      )
    })

    storyboard.DOM.zoomInBtn = document.getElementById('zoom-in')
    storyboard.DOM.zoomInBtn.addEventListener('click', function (e) {
      storyboard.viewer.viewport.zoomBy(storyboard.viewerOptions.defaultZoomIn)
      if (
        storyboard.viewer.viewport.getZoom() >
        storyboard.viewer.viewport.getMaxZoom()
      ) {
        storyboard.viewer.viewport.zoomTo(
          storyboard.viewer.viewport.getMaxZoom(),
        )
      }
    })

    storyboard.DOM.zoomOutBtn = document.getElementById('zoom-out')
    storyboard.DOM.zoomOutBtn.addEventListener('click', function (e) {
      storyboard.viewer.viewport.zoomBy(storyboard.viewerOptions.defaultZoomOut)
      if (
        storyboard.viewer.viewport.getZoom() <
        storyboard.viewer.viewport.getMinZoom()
      ) {
        storyboard.viewer.viewport.zoomTo(
          storyboard.viewer.viewport.getMinZoom(),
        )
      }
    })

    storyboard.DOM.fullScreenBtn = document.getElementById('fullScreen')
    storyboard.DOM.fullScreenBtn.addEventListener('click', function (e) {
      if (screenfull.isEnabled) {
        screenfull.toggle()
      }
    })

    storyboard.DOM.storyProgress = document.getElementById('storyProgress')
    storyboard.DOM.toolbar = document.getElementById('toolBar')
    storyboard.DOM.toolbarButtons = document.getElementById('toolbarButtons')

    if (onPremises) {
      this.onPremisesSetup(storyboard)
    }
  },

  onPremisesSetup: function (storyboard) {
    storyboard.DOM.toolbar.classList.add('onPremises')
    document
      .getElementById('navigatorAndButtonsContainer')
      .classList.add('onPremises')
    document.getElementById('navigatorContainer').classList.add('onPremises')
    document.querySelector('.homepageBtn').classList.add('onPremises')
    storyboard.DOM.creditsImage.classList.add('onPremises')
    storyboard.DOM.creditsImage.classList.add('onPremises')
    storyboard.DOM.stepContentWidget.classList.add('onPremises')
    storyboard.DOM.stepContentToggle.classList.add('onPremises')
  },
}
